// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"document_banner2_wrapper__2w8Ik","action_btn":"document_banner2_action_btn__Hvr77"};